export enum InnerNavPositions {
  Top = 'top',
  Left = 'left',
}
